import { z } from "zod"

// "name": "山田 太郎",
// "firstName": "山田",
// "lastName": "太郎",
// "password": "password12345",
// "email": "hoge@example.com",
// "phoneNumber": "1111111111",
// "address": "asdf",
// "callbackURL": "http://localhost:5179/signin"

export const passwordZ = z
  .string({ message: "パスワードを入力してください" })
  .min(8, "8文字以上で入力してください")
  .regex(/^[0-9A-Za-z]+$/, "半角英数字のみで入力してください")

export const signUpEmailRequestSchema = z.object({
  name: z.string().min(1, "名前を入力してください"),
  lastName: z.string().min(1, "姓を入力してください"),
  firstName: z.string().min(1, "名を入力してください"),
  email: z
    .string()
    .min(1, "メールアドレスを入力してください")
    .email("有効なメールアドレスを入力してください"),
  phoneNumber: z
    .string()
    .min(1, "電話番号を入力してください")
    .regex(/^[0-9]{10,11}$/, "電話番号は10〜11桁の数字で入力してください"),
  address: z.string().min(1, "住所を入力してください"),
  emergencyPhoneNumber: z
    .string()
    .regex(/^[0-9]{10,11}$/, "緊急用電話番号は10〜11桁の数字で入力してください")
    .optional()
    .or(z.literal("")),
  password: passwordZ,
  callbackURL: z.string().optional(),
})

export const signInEmailRequestSchema = z.object({
  email: z
    .string()
    .min(1, "メールアドレスを入力してください")
    .email("有効なメールアドレスを入力してください"),
  password: passwordZ,
  callbackURL: z.string().optional(),
})

export const authResponseSchema = z.object({
  user: z.object({
    id: z.string(),
    email: z.string().email(),
    name: z.string().optional(),
    createdAt: z.string().optional(),
  }),
  token: z.string().optional(),
})

export const updateProfileRequestSchema = z.object({
  name: z.string().min(1, "氏名を入力してください"),
  nameKana: z.string().optional(),
  phone: z
    .string()
    .min(1, "電話番号を入力してください")
    .regex(/^\d{10,11}$/, "電話番号は10〜11桁の数字で入力してください"),
  emergencyPhone: z
    .string()
    .regex(/^\d{10,11}$/, "緊急用電話番号は10〜11桁の数字で入力してください")
    .optional()
    .or(z.literal("")),
  postalCode: z
    .string()
    .refine((val) => val === "" || /^\d{7}$/.test(val), {
      message: "郵便番号は7桁の数字で入力してください",
    })
    .optional(),
  address: z.string().min(1, "住所を入力してください"),
})

export const changeEmailRequestSchema = z.object({
  newEmail: z
    .string()
    .min(1, "新しいメールアドレスを入力してください")
    .email("正しいメールアドレス形式で入力してください"),
})

export const changePasswordRequestSchema = z.object({
  currentPassword: z.string().min(1, "現在のパスワードを入力してください"),
  newPassword: passwordZ,
})

export const forgetPasswordRequestSchema = z.object({
  email: z
    .string()
    .min(1, "メールアドレスを入力してください")
    .email("有効なメールアドレスを入力してください"),
})

export const resetPasswordRequestSchema = z.object({
  newPassword: passwordZ,
  token: z.string().nullable(),
})

export type SignUpEmailRequest = z.infer<typeof signUpEmailRequestSchema>
export type SignInEmailRequest = z.infer<typeof signInEmailRequestSchema>
export type AuthResponse = z.infer<typeof authResponseSchema>
export type UpdateProfileRequest = z.infer<typeof updateProfileRequestSchema>
export type ChangeEmailRequest = z.infer<typeof changeEmailRequestSchema>
export type ChangePasswordRequest = z.infer<typeof changePasswordRequestSchema>
export type ForgetPasswordRequest = z.infer<typeof forgetPasswordRequestSchema>
export type ResetPasswordRequest = z.infer<typeof resetPasswordRequestSchema>
